import React from "react";
import cn from "classnames";
import styles from "./PageSkeleton.module.scss";

const ROWS = 8;

/**
 * Shown while a page's code loads: a page header and a table, the shape of
 * most pages, so the content doesn't pop in under an empty shell.
 */
export const PageSkeleton = () => (
  <div className={styles.page} role="status" aria-label="Loading page">
    <div className={styles.header}>
      <span className={cn(styles.bar, styles.title)} />
      <span className={cn(styles.bar, styles.action)} />
    </div>
    <div className={styles.table}>
      <div className={styles.toolbar}>
        <span className={cn(styles.bar, styles.search)} />
        <span className={cn(styles.bar, styles.filter)} />
      </div>
      {Array.from({ length: ROWS }, (_, index) => (
        <div key={index} className={styles.row}>
          <span
            className={styles.bar}
            style={{ width: `${30 + ((index * 17) % 40)}%` }}
          />
          <span
            className={styles.bar}
            style={{ width: `${15 + ((index * 11) % 20)}%` }}
          />
        </div>
      ))}
    </div>
  </div>
);

/** Shown while a form in a route drawer loads. */
export const FormSkeleton = () => (
  <div className={styles.form} role="status" aria-label="Loading form">
    {Array.from({ length: 5 }, (_, index) => (
      <div key={index} className={styles.field}>
        <span className={cn(styles.bar, styles.label)} />
        <span className={cn(styles.bar, styles.control)} />
      </div>
    ))}
  </div>
);
